import axios from 'axios';

import { IDeviceExclusionList } from '@/shared/model/device-exclusion-list.model';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

const baseApiUrl = 'api/device-exclusion-list';

export default class DeviceExclusionListService {
  public find(orgId: number): Promise<IDeviceExclusionList[]> {
    return new Promise<IDeviceExclusionList[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${orgId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveByOrgIdAndAction(orgId: number, action: string, paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/orgId/${orgId}?action=${action}&${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public search(deviceExclusionListArray: IDeviceExclusionList, paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('api/_search/device-exclusion-list' + '?' + buildPaginationQueryOpts(paginationQuery), deviceExclusionListArray)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IDeviceExclusionList): Promise<IDeviceExclusionList> {
    return new Promise<IDeviceExclusionList>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IDeviceExclusionList): Promise<IDeviceExclusionList> {
    return new Promise<IDeviceExclusionList>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public checkDeviceExclusionList(entity: IDeviceExclusionList): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/check-exclusion-list?organization.id=${entity.organization.id}&serialNumber=${entity.serialNumber}&action=${entity.action.toString()}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public checkDeviceExclusionListExistsByAction(entity: IDeviceExclusionList): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/check-exclusion-list-exists?action=${entity.action.toString()}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}
